// PRODUCTION — live-updates affected-contractor counts (total + per-state chips).
import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { Chip } from 'src/components/shared/Chip'
import { GSIcon } from 'src/components/shared/GSIcon'
import type { CollectDataTemplatePreviewStepCounts } from 'src/interfaces/collectDataTemplatePreview'
import { humanize } from './previewFormatting'

interface CountsRowProps {
  counts: CollectDataTemplatePreviewStepCounts
}

const CountsRowComponent = ({ counts }: CountsRowProps) => {
  return (
    <div css={tw`flex flex-col gap-2 rounded-[10px] bg-shades-50 p-2.5`}>
      <div css={tw`flex items-center gap-1.5`}>
        <GSIcon iconName="gs_people" width={20} height={16} css={tw`fill-shades-700`} />
        <Typography variant="h6" css={tw`text-shades-900`}>
          {counts.total.toLocaleString()}
        </Typography>
        <Typography variant="body2" css={tw`text-shades-500`}>
          {counts.total === 1 ? 'contractor affected' : 'contractors affected'}
        </Typography>
      </div>

      {counts.byState.length > 0 && (
        <div css={tw`flex flex-wrap gap-1`}>
          {counts.byState.map((entry) => {
            return (
              <Chip
                key={entry.state}
                text={`${humanize(entry.state)} · ${entry.count.toLocaleString()}`}
                className={tw`bg-shades-100`}
                textClassName={tw`text-shades-700`}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

export const CountsRow = memo(CountsRowComponent)
